// extracted by mini-css-extract-plugin
module.exports = {"root":"_4059c1","column":"_9ecd3f","row":"_e7eb62"};